(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // Anlass-Daten (hardcoded)
  // ---------------------------------------------------------------------------

  var ANLASS_OPTIONS = [
    { id: 'speise',   emoji: '🍽️', label: 'Zum Essen',    tag: 'anlass-speise',   hasEssen: true  },
    { id: 'geschenk', emoji: '🎁', label: 'Als Geschenk', tag: 'anlass-geschenk', hasEssen: false },
    { id: 'alltag',   emoji: '✨', label: 'Für mich',     tag: 'anlass-alltag',   hasEssen: false },
  ];

  // ---------------------------------------------------------------------------
  // Alltag-Funnel-Daten
  // ---------------------------------------------------------------------------

  var LUST_OPTIONS = [
    { id: 'rotwein',     emoji: '🍷', label: 'Rotwein',           weinart: 'rot'       },
    { id: 'weisswein',   emoji: '🥂', label: 'Weißwein',          weinart: 'weiss'     },
    { id: 'rose',        emoji: '🌹', label: 'Rosé',              weinart: 'rose'      },
    { id: 'prickelnd',   emoji: '🍾', label: 'Prickelnd',         weinart: 'schaumwein'},
    { id: 'ausgefallen', emoji: '🌿', label: 'Was Ausgefallenes', weinart: null        },
    { id: 'ueberrasch',  emoji: '✨', label: 'Überrasch mich',    weinart: null        },
  ];

  var SELTENE_REBSORTEN = [
    'grüner veltliner', 'blaufränkisch', 'zweigelt', 'furmint',
    'assyrtiko', 'xinomavro', 'nero d\'avola', 'nerello mascalese',
    'aglianico', 'vermentino', 'godello', 'albariño', 'mencía',
    'trousseau', 'poulsard', 'savagnin', 'jacquère',
  ];

  // ---------------------------------------------------------------------------
  // Geschenk-Funnel-Daten
  // ---------------------------------------------------------------------------

  var EMPFAENGER_OPTIONS = [
    { id: 'geniesser',   emoji: '🍷', label: 'Kenner/in',                subline: 'Trinkt gern und kennt sich aus',   hasFarbe: true  },
    { id: 'gelegenheit', emoji: '🥂', label: 'Gelegenheitstrinker/in',   subline: 'Ab und zu ein Glas, kein Experte', hasFarbe: true, allowedFarben: ['rot', 'weiss', 'rose'] },
    { id: 'ausgefallen', emoji: '🌿', label: 'Ausgefallen & Besonders',  subline: 'Naturwein, Orange & Co.',          hasFarbe: false },
    { id: 'business',    emoji: '🏢', label: 'Geschäftlich',             subline: 'Kunden, Kollegen, Chef',           hasFarbe: true, allowedFarben: ['rot', 'weiss', 'schaumwein', 'rose'] },
    { id: 'unbekannt',   emoji: '🎁', label: 'Ich kenne die Person kaum', subline: 'Sicherer Tipp, der immer passt',  hasFarbe: false },
  ];

  var GIFT_BUDGET_OPTIONS = [
    { id: 'klein',   emoji: '🎈', label: 'Kleine Aufmerksamkeit', min: 0,  max: 12  },
    { id: 'mittel',  emoji: '🎁', label: 'Solides Geschenk',     min: 12, max: 18, highlight: true },
    { id: 'gehoben', emoji: '✨', label: 'Etwas Besonderes',     min: 18, max: 28  },
    { id: 'premium', emoji: '🏆', label: 'Beeindruckend',        min: 28, max: 999 },
  ];

  var GIFT_PROFILES = {
    'geniesser':   { preisMin: 12, weinartFilter: null,                                  requireTag: null, geschmackTags: ['geschmack-vollmundig', 'geschmack-trocken'], useRange: true },
    'gelegenheit': { preisMin: 0,  weinartFilter: null,                                  requireTag: null, geschmackTag: 'geschmack-fruchtig' },
    'ausgefallen': { preisMin: 0,  weinartFilter: null,                                  requireTag: null, isAusgefallen: true },
    'business':    { preisMin: 14, weinartFilter: null,                                  requireTag: null, fixedMax: true },
    'unbekannt':   { preisMin: 0,  weinartFilter: null,                                  requireTag: null },
  };

  // ---------------------------------------------------------------------------
  // Essen-Daten (nur für Anlass = Speise)
  // ---------------------------------------------------------------------------

  var ESSEN_OPTIONS = [
    { id: 'grillen',   emoji: '🔥', label: 'Grillen',               phrase: 'Gegrilltem',                    tags: ['speise-fleisch', 'speise-gegrillt'],   needsFollowUp: false },
    { id: 'pasta',     emoji: '🍝', label: 'Pasta',                 phrase: 'Pasta',                         tags: ['speise-pasta'],                        needsFollowUp: true  },
    { id: 'pizza',     emoji: '🍕', label: 'Pizza',                 phrase: 'Pizza',                         tags: ['speise-pasta'],                        needsFollowUp: false },
    { id: 'braten',    emoji: '🥩', label: 'Braten & Schmoren',     phrase: 'Braten und Schmorgerichten',    tags: ['speise-fleisch', 'speise-geschmort'],  needsFollowUp: false },
    { id: 'salat',     emoji: '🥗', label: 'Salat & leichte Küche', phrase: 'Salat und leichter Küche',      tags: ['speise-vegetarisch', 'speise-frisch'], needsFollowUp: false },
    { id: 'fisch',     emoji: '🐟', label: 'Fisch',                 phrase: 'Fisch',                         tags: ['speise-fisch'],                        needsFollowUp: true  },
    { id: 'asiacurry', emoji: '🌶️', label: 'Asia, Curry & Co.',    phrase: 'Asia- und Curry-Gerichten',     tags: ['speise-wuerzig', 'speise-asiatisch'],  needsFollowUp: false },
    { id: 'kaese',     emoji: '🧀', label: 'Käse & Aperitif',       phrase: 'Käse und Aperitif',             tags: ['speise-kaese'],                        needsFollowUp: false },
    { id: 'veggie',    emoji: '🍄', label: 'Veggie & Gemüse',       phrase: 'Gemüsegerichten',               tags: ['speise-vegetarisch'],                  needsFollowUp: true  },
  ];

  var ESSEN_FOLLOWUPS = {
    pasta: [
      { id: 'pasta-tomate',  emoji: '🍅', label: 'Tomate / Sugo',              phrase: 'Pasta mit Tomatensoße oder Sugo',    tags: ['speise-tomate'] },
      { id: 'pasta-sahne',   emoji: '🧀', label: 'Sahne / Käse / Carbonara',   phrase: 'Pasta mit Sahne oder Carbonara',     tags: ['speise-sahne'] },
      { id: 'pasta-pesto',   emoji: '🌿', label: 'Pesto / Kräuter / Olivenöl', phrase: 'Pasta mit Pesto oder Kräutern',      tags: ['speise-frisch'] },
      { id: 'pasta-ragout',  emoji: '🥩', label: 'Ragù / Bolognese / Fleisch', phrase: 'Pasta mit Ragù oder Bolognese',      tags: ['speise-tomate', 'speise-fleisch'] },
    ],
    fisch: [
      { id: 'fisch-pur',       emoji: '🍋', label: 'Gedünstet / gegrillt',     phrase: 'gedünstetem oder gegrilltem Fisch',  tags: ['speise-gegrillt'] },
      { id: 'fisch-sauce',     emoji: '🧈', label: 'In Sauce / Gratin',        phrase: 'Fisch in Sauce oder Gratin',         tags: ['speise-butter'] },
      { id: 'fisch-asiatisch', emoji: '🥢', label: 'Asiatisch zubereitet',     phrase: 'asiatisch zubereitetem Fisch',       tags: ['speise-asiatisch'] },
      { id: 'fisch-roh',       emoji: '🍣', label: 'Roh / Sushi / Carpaccio',  phrase: 'rohem Fisch oder Sushi',             tags: ['speise-frisch'] },
    ],
    veggie: [
      { id: 'veg-gegrillt',    emoji: '🔥', label: 'Gegrillt / geröstet',      phrase: 'gegrilltem oder geröstetem Gemüse',  tags: ['speise-gegrillt'] },
      { id: 'veg-geschmort',   emoji: '🫕', label: 'Eintopf / Ratatouille',    phrase: 'Eintopf oder Ratatouille',           tags: ['speise-geschmort'] },
      { id: 'veg-pilze',       emoji: '🍄', label: 'Pilze / Umami-reich',      phrase: 'Pilzgerichten',                      tags: ['speise-pilze'] },
      { id: 'veg-ueberbacken', emoji: '🧀', label: 'Überbacken / Auflauf',     phrase: 'überbackenem Gemüse oder Auflauf',   tags: ['speise-sahne'] },
    ],
  };

  var FOLLOWUP_QUESTIONS = {
    pasta:  'Welche Sauce?',
    fisch:  'Wie zubereitet?',
    veggie: 'Welche Art?',
  };

  // ---------------------------------------------------------------------------
  // State
  // ---------------------------------------------------------------------------

  var state = {
    stepHistory: ['anlass'],
    anlass:      null,   // selected ANLASS_OPTIONS entry
    essen:       null,   // selected ESSEN_OPTIONS entry (nur wenn anlass.hasEssen)
    essenSub:    null,   // selected followup entry or null
    farbe:       null,   // tag string or null (null = Überrasch mich)
    geschmack:   null,   // tag string or null
    budget:      20,
    empfaenger:  null,   // selected EMPFAENGER_OPTIONS entry (nur Geschenk-Funnel)
    giftBudget:  null,   // selected GIFT_BUDGET_OPTIONS entry (nur Geschenk-Funnel)
    lust:        null,   // selected LUST_OPTIONS entry (nur Alltag-Funnel)
    lustBudget:  14,     // Slider-Wert (nur Alltag-Funnel)
    alltagShown:    [],  // IDs bereits gezeigter Weine (Für mich)
    currentResults: [], // Sortierte Treffer des letzten renderResults()-Aufrufs
    shuffleOffset:  0,  // Aktueller Offset für Essen/Geschenk-Shuffle
  };

  // ---------------------------------------------------------------------------
  // Helpers
  // ---------------------------------------------------------------------------

  function escHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getRoot() {
    return document.querySelector('.weinfinder');
  }

  function getAllFunnelTags(p) {
    return normalizeTags(p.funnel_tags).concat(normalizeTags(p.geschmack_tags));
  }

  function normalizeTags(raw) {
    if (!raw) return [];
    var items = Array.isArray(raw) ? raw : String(raw).split(/[\n,]/);
    var result = [];
    items.forEach(function (item) {
      String(item).split(/[\n,]/).forEach(function (t) {
        t = t.trim().toLowerCase();
        if (t) result.push(t);
      });
    });
    return result;
  }

  var WEINART_MAP = {
    'rotwein':    'rot',
    'weißwein':   'weiss',
    'weisswein':  'weiss',
    'rose':       'rose',
    'orange':     'orange',
    'schaumwein': 'schaumwein',
  };

  function normalizeWeinart(raw) {
    if (!raw) return null;
    var s = raw.trim().toLowerCase()
      .replace(/[éèê]/g, 'e')
      .replace(/ß/g,     'ss')
      .replace(/[öô]/g,  'o')
      .replace(/[üû]/g,  'u')
      .replace(/[äâ]/g,  'a');
    return WEINART_MAP[s] || s;
  }

  // Weinart aus Metafeld ODER regulären Shopify-Tags ableiten
  function getProductWeinart(p) {
    var fromMeta = normalizeWeinart(p.weinart);
    if (fromMeta) return fromMeta;
    var tags = normalizeTags(p.tags);
    for (var i = 0; i < tags.length; i++) {
      var t = tags[i].replace(/[éèê]/g, 'e').replace(/ß/g, 'ss');
      if (WEINART_MAP[t]) return WEINART_MAP[t];
    }
    return null;
  }

  // ---------------------------------------------------------------------------
  // Step flow
  // ---------------------------------------------------------------------------

  function getStepFlow() {
    var flow = ['anlass'];

    if (state.anlass && state.anlass.id === 'geschenk') {
      flow.push('empfaenger');
      if (state.empfaenger && state.empfaenger.hasFarbe) {
        flow.push('farbe');
      }
      flow.push('giftbudget');
    } else if (state.anlass && state.anlass.id === 'alltag') {
      flow.push('lust', 'lustbudget');
    } else {
      if (state.anlass && state.anlass.hasEssen) {
        flow.push('essen');
        if (state.essen && state.essen.needsFollowUp) {
          flow.push('essensub');
        }
      }
      flow.push('farbe', 'geschmack');
      var cfg = window.WEINFINDER_CONFIG || {};
      if (cfg.show_budget && cfg.budget_position === 'step') {
        flow.push('budget');
      }
    }

    flow.push('results');
    return flow;
  }

  function getCurrentStep() {
    return state.stepHistory[state.stepHistory.length - 1];
  }

  // ---------------------------------------------------------------------------
  // Progress
  // ---------------------------------------------------------------------------

  function updateProgress() {
    var flow      = getStepFlow();
    var quizSteps = flow.filter(function (s) { return s !== 'results'; });
    var current   = getCurrentStep();
    var idx       = quizSteps.indexOf(current);
    var total     = quizSteps.length;
    var num       = current === 'results' ? total : Math.max(idx + 1, 1);

    var fill = document.getElementById('wf-progress-fill');
    if (fill) fill.style.width = ((num / total) * 100) + '%';

    var label = document.getElementById('wf-step-label');
    if (label) label.textContent = num;

    var totalEl = document.getElementById('wf-step-total');
    if (totalEl) totalEl.textContent = total;

    var progressBar = document.querySelector('.wf-progress-bar');
    if (progressBar) progressBar.setAttribute('aria-valuenow', num);
  }

  // ---------------------------------------------------------------------------
  // Transitions
  // ---------------------------------------------------------------------------

  function activateStepEl(el) {
    el.classList.add('active');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('visible'); });
    });
  }

  function transitionStep(fromName, toName) {
    var fromEl = document.querySelector('.wf-step[data-step="' + fromName + '"]');
    var toEl   = document.querySelector('.wf-step[data-step="' + toName   + '"]');
    if (!toEl) return;

    if (fromEl) {
      fromEl.classList.remove('visible');
      setTimeout(function () {
        fromEl.classList.remove('active');
        activateStepEl(toEl);
      }, 350);
    } else {
      activateStepEl(toEl);
    }
  }

  // ---------------------------------------------------------------------------
  // Navigation
  // ---------------------------------------------------------------------------

  function goToStep(stepName) {
    var from = getCurrentStep();
    state.stepHistory.push(stepName);
    updateProgress();

    if (stepName === 'essensub')   renderEssenSubStep();
    else if (stepName === 'lustbudget') renderLustBudgetStep();
    else if (stepName === 'giftbudget') renderGiftBudgetStep();
    else if (stepName === 'results') renderResults();

    if (stepName === 'farbe')     updateFarbeButtons();
    if (stepName === 'geschmack') updateGeschmackButtons();

    transitionStep(from, stepName);
  }

  function goNext() {
    var flow = getStepFlow();
    var idx  = flow.indexOf(getCurrentStep());
    if (idx < flow.length - 1) goToStep(flow[idx + 1]);
  }

  function goPrev() {
    if (state.stepHistory.length <= 1) return;

    var leaving = getCurrentStep();
    if (leaving === 'essen')      { state.essen      = null; state.essenSub = null; }
    if (leaving === 'essensub')   state.essenSub   = null;
    if (leaving === 'farbe')      state.farbe      = null;
    if (leaving === 'geschmack')  state.geschmack  = null;
    if (leaving === 'empfaenger') { state.empfaenger = null; state.farbe = null; }
    if (leaving === 'giftbudget') state.giftBudget = null;
    if (leaving === 'lust')       { state.lust = null; state.alltagShown = []; }
    if (leaving === 'lustbudget') state.lustBudget = 14;

    state.stepHistory.pop();
    var prev = getCurrentStep();
    updateProgress();

    if (prev === 'farbe')     updateFarbeButtons();
    if (prev === 'geschmack') updateGeschmackButtons();

    transitionStep(leaving, prev);
  }

  // ---------------------------------------------------------------------------
  // renderEssenSubStep
  // ---------------------------------------------------------------------------

  function renderEssenSubStep() {
    var container = document.getElementById('wf-step-essensub');
    if (!container || !state.essen) return;

    var options  = ESSEN_FOLLOWUPS[state.essen.id] || [];
    var question = FOLLOWUP_QUESTIONS[state.essen.id] || 'Genauer?';

    container.innerHTML =
      '<button class="wf-back" type="button" data-goto="prev">' +
        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
          '<path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
        ' Zurück' +
      '</button>' +
      '<h3 class="wf-step-question">' + escHtml(question) + '</h3>' +
      '<div class="wf-options-grid">' +
        options.map(function (opt) {
          return '<button class="wf-option" type="button" data-essensub-id="' + escHtml(opt.id) + '">' +
            (opt.emoji ? '<span class="wf-option-emoji">' + escHtml(opt.emoji) + '</span>' : '') +
            escHtml(opt.label) +
          '</button>';
        }).join('') +
      '</div>';
  }

  // ---------------------------------------------------------------------------
  // renderGiftBudgetStep
  // ---------------------------------------------------------------------------

  function countProductsForGiftBudget(budgetOpt) {
    var profile  = state.empfaenger ? (GIFT_PROFILES[state.empfaenger.id] || {}) : {};
    var farbeTag = (state.farbe && state.farbe !== 'null') ? state.farbe.toLowerCase() : null;
    var products = window.WEINFINDER_PRODUCTS || [];
    return products.filter(function (p) {
      var funnelTags = getAllFunnelTags(p);
      var weinart    = normalizeWeinart(p.weinart);
      if (p.price < (profile.preisMin || 0))                                   return false;
      if (p.price < budgetOpt.min || p.price > budgetOpt.max)                  return false;
      if (profile.requireTag && funnelTags.indexOf(profile.requireTag) === -1)  return false;
      if (profile.weinartFilter && profile.weinartFilter.indexOf(weinart) === -1) return false;
      if (farbeTag && weinart !== farbeTag)                                      return false;
      return true;
    }).length;
  }

  function renderGiftBudgetStep() {
    var container = document.getElementById('wf-step-giftbudget');
    if (!container) return;

    var backBtn =
      '<button class="wf-back" type="button" data-goto="prev">' +
        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
          '<path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
        ' Zurück' +
      '</button>';

    // Geschäftlich: Slider statt Kacheln
    if (state.empfaenger && state.empfaenger.id === 'business') {
      var defaultVal = state.giftBudget ? state.giftBudget.max : 30;
      state.giftBudget = { id: 'slider', min: 14, max: defaultVal };
      state.budget     = defaultVal;

      container.innerHTML =
        backBtn +
        '<h3 class="wf-step-question">Was darf\'s kosten?</h3>' +
        '<div class="wf-slider-wrap">' +
          '<div class="wf-budget-display">' +
            '<span class="wf-budget-amount" id="wf-giftbudget-amount">' + defaultVal + '</span>' +
            '<span class="wf-budget-label">Euro ungefähr</span>' +
          '</div>' +
          '<input' +
            ' type="range"' +
            ' class="wf-slider"' +
            ' id="wf-giftbudget-slider"' +
            ' min="14"' +
            ' max="80"' +
            ' value="' + defaultVal + '"' +
            ' step="1"' +
            ' aria-label="Budget in Euro"' +
            ' aria-valuemin="14"' +
            ' aria-valuemax="80"' +
            ' aria-valuenow="' + defaultVal + '"' +
          '>' +
          '<div class="wf-slider-range">' +
            '<span>14 €</span>' +
            '<span>80 €</span>' +
          '</div>' +
        '</div>' +
        '<button class="wf-btn-primary" type="button" data-goto="next">Weine zeigen</button>';

      var slider   = document.getElementById('wf-giftbudget-slider');
      var amountEl = document.getElementById('wf-giftbudget-amount');
      if (slider) {
        updateSliderGradient(slider);
        slider.addEventListener('input', function () {
          var val = parseInt(slider.value, 10);
          state.giftBudget = { id: 'slider', min: 14, max: val };
          state.budget     = val;
          slider.setAttribute('aria-valuenow', val);
          if (amountEl) amountEl.textContent = val;
          updateSliderGradient(slider);
        });
      }
      var weiterBtn = container.querySelector('.wf-btn-primary[data-goto="next"]');
      if (weiterBtn) {
        weiterBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          goNext();
        });
      }
      return;
    }

    // Alle anderen Empfänger: Kacheln
    var counts     = GIFT_BUDGET_OPTIONS.map(countProductsForGiftBudget);
    var anyNonZero = counts.some(function (c) { return c > 0; });
    var visibleOpts = anyNonZero
      ? GIFT_BUDGET_OPTIONS.filter(function (opt, i) { return counts[i] > 0; })
      : GIFT_BUDGET_OPTIONS;

    // Nur eine Option: automatisch wählen und überspringen
    if (visibleOpts.length === 1) {
      state.giftBudget = visibleOpts[0];
      state.budget     = visibleOpts[0].max;
      goNext();
      return;
    }

    var tilesHtml = visibleOpts.map(function (opt) {
      return '<button class="wf-option' + (opt.highlight ? ' wf-option--highlight' : '') + '" type="button" data-giftbudget-id="' + escHtml(opt.id) + '">' +
        '<span class="wf-option-emoji">' + escHtml(opt.emoji) + '</span>' +
        escHtml(opt.label) +
      '</button>';
    }).join('');

    container.innerHTML =
      backBtn +
      '<h3 class="wf-step-question">Was darf\'s kosten?</h3>' +
      '<div class="wf-options-grid">' + tilesHtml + '</div>';
  }

  // ---------------------------------------------------------------------------
  // renderLustBudgetStep
  // ---------------------------------------------------------------------------

  function renderLustBudgetStep() {
    var container = document.getElementById('wf-step-lustbudget');
    if (!container) return;

    container.innerHTML =
      '<button class="wf-back" type="button" data-goto="prev">' +
        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
          '<path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
        ' Zurück' +
      '</button>' +
      '<h3 class="wf-step-question">Wieviel möchtest du ungefähr ausgeben?</h3>' +
      '<div class="wf-slider-wrap">' +
        '<div class="wf-budget-display">' +
          '<span class="wf-budget-amount" id="wf-lustbudget-amount">' + state.lustBudget + '</span>' +
          '<span class="wf-budget-label">Euro ungefähr</span>' +
        '</div>' +
        '<input' +
          ' type="range"' +
          ' class="wf-slider"' +
          ' id="wf-lustbudget-slider"' +
          ' min="6"' +
          ' max="40"' +
          ' value="' + state.lustBudget + '"' +
          ' step="1"' +
          ' aria-label="Budget in Euro"' +
          ' aria-valuemin="6"' +
          ' aria-valuemax="40"' +
          ' aria-valuenow="' + state.lustBudget + '"' +
        '>' +
        '<div class="wf-slider-range">' +
          '<span>6 €</span>' +
          '<span>40 €</span>' +
        '</div>' +
      '</div>' +
      '<button class="wf-btn-primary" type="button" data-goto="next">Weine zeigen</button>';

    var slider   = document.getElementById('wf-lustbudget-slider');
    var amountEl = document.getElementById('wf-lustbudget-amount');
    if (slider) {
      updateSliderGradient(slider);
      slider.addEventListener('input', function () {
        var val = parseInt(slider.value, 10);
        state.lustBudget = val;
        slider.setAttribute('aria-valuenow', val);
        if (amountEl) amountEl.textContent = val;
        updateSliderGradient(slider);
      });
    }

    // Direkter Handler als Fallback – verhindert Probleme mit Theme-stopPropagation
    var weiterBtn = container.querySelector('.wf-btn-primary[data-goto="next"]');
    if (weiterBtn) {
      weiterBtn.addEventListener('click', function (e) {
        e.stopPropagation(); // verhindert Doppel-Auslösung durch delegierten Handler
        goNext();
      });
    }
  }

  // ---------------------------------------------------------------------------
  // Available-option helpers (for button visibility)
  // ---------------------------------------------------------------------------

  function getAvailableWeinarten() {
    var products = window.WEINFINDER_PRODUCTS || [];
    var available = {};

    if (state.empfaenger) {
      // Geschenk-Funnel: Anlass-Tag nicht prüfen, stattdessen Profil-Filter anwenden
      var profile  = GIFT_PROFILES[state.empfaenger.id] || {};
      products.forEach(function (p) {
        var funnelTags = getAllFunnelTags(p);
        var weinart    = getProductWeinart(p);
        if (profile.requireTag && funnelTags.indexOf(profile.requireTag) === -1) return;
        if (profile.weinartFilter && profile.weinartFilter.indexOf(weinart) === -1) return;
        if (p.price < (profile.preisMin || 0)) return;
        if (weinart) available[weinart] = true;
      });
    } else {
      var speiseTags = getActiveSpeiseTags();
      products.forEach(function (p) {
        var funnelTags = getAllFunnelTags(p);
        var weinart    = getProductWeinart(p);
        if (!speiseTags.every(function (t) { return funnelTags.indexOf(t) !== -1; })) return;
        if (weinart) available[weinart] = true;
      });
    }

    return available;
  }

  function getAvailableGeschmack() {
    var speiseTags = getActiveSpeiseTags();
    var farbeTag   = (state.farbe && state.farbe !== 'null') ? state.farbe.toLowerCase() : null;
    var products   = window.WEINFINDER_PRODUCTS || [];
    var available  = {};

    products.forEach(function (p) {
      var funnelTags = getAllFunnelTags(p);
      var weinart    = normalizeWeinart(p.weinart);
      if (!speiseTags.every(function (t) { return funnelTags.indexOf(t) !== -1; })) return;
      if (farbeTag && weinart !== farbeTag) return;
      funnelTags.forEach(function (t) {
        if (t.indexOf('geschmack-') === 0) available[t] = true;
      });
    });

    return available;
  }

  function updateFarbeButtons() {
    var stepEl       = document.querySelector('.wf-step[data-step="farbe"]');
    if (!stepEl) return;
    var available    = getAvailableWeinarten();
    var hasAny       = Object.keys(available).length > 0;
    var allowedFarben = state.empfaenger && state.empfaenger.allowedFarben ? state.empfaenger.allowedFarben : null;

    stepEl.querySelectorAll('.wf-option[data-tag]').forEach(function (btn) {
      var tag = btn.dataset.tag;
      if (tag === 'null') { btn.style.display = ''; return; }  // "Überrasch mich" always visible
      if (allowedFarben && allowedFarben.indexOf(tag) === -1) { btn.style.display = 'none'; return; }
      // Wenn keine Produkte mit Weinart-Daten: alle Optionen zeigen
      btn.style.display = (!hasAny || available[tag]) ? '' : 'none';
    });
  }

  function updateGeschmackButtons() {
    var stepEl    = document.querySelector('.wf-step[data-step="geschmack"]');
    if (!stepEl) return;
    var available = getAvailableGeschmack();
    var hasAny    = Object.keys(available).length > 0;

    stepEl.querySelectorAll('.wf-option[data-tag]').forEach(function (btn) {
      var tag = btn.dataset.tag;
      if (tag === 'null') { btn.style.display = ''; return; }  // "Überrasch mich" always visible
      // Wenn keine Produkte mit geschmack-Tags gefunden: alle Optionen zeigen
      btn.style.display = (!hasAny || available[tag]) ? '' : 'none';
    });
  }

  // ---------------------------------------------------------------------------
  // applyBudgetRange — ca. -10% bis +20%, expandiert wenn leer
  // ---------------------------------------------------------------------------

  function applyBudgetRange(products, budget) {
    if (!budget || budget <= 0) return products;
    var tight = budget < 15;
    var loBase = tight ? 0.95 : 0.90;  // unter 15€: engerer Rahmen -5% statt -10%
    var hiBase = tight ? 1.10 : 1.20;  // unter 15€: engerer Rahmen +10% statt +20%
    var step = 0;
    var lo, hi, result;
    do {
      lo = Math.max(0, budget * (loBase - step * 0.1));
      hi = budget * (hiBase + step * 0.1);
      result = products.filter(function (p) { return p.price >= lo && p.price <= hi; });
      step++;
    } while (result.length === 0 && step <= 10);
    return result.length > 0 ? result : products;
  }

  // ---------------------------------------------------------------------------
  // filterProducts
  // ---------------------------------------------------------------------------

  function getActiveSpeiseTags() {
    var tags = [];
    if (state.essen) {
      state.essen.tags.forEach(function (t) { tags.push(t.toLowerCase()); });
    }
    if (state.essenSub) {
      state.essenSub.tags.forEach(function (t) {
        if (tags.indexOf(t.toLowerCase()) === -1) tags.push(t.toLowerCase());
      });
    }
    return tags;
  }

  function filterProducts() {
    var products  = window.WEINFINDER_PRODUCTS || [];

    // ---- Geschenk-Funnel ----
    if (state.empfaenger) {
      var profile    = GIFT_PROFILES[state.empfaenger.id] || {};
      var giftMin    = state.giftBudget ? state.giftBudget.min : 0;
      var giftMax    = state.giftBudget ? state.giftBudget.max : 999;
      var preisMin   = profile.preisMin || 0;
      var farbeTag   = (state.farbe && state.farbe !== 'null') ? state.farbe.toLowerCase() : null;

      // Nicht-Preis-Filter: Farbe, Tags etc.
      var candidates = products.filter(function (p) {
        var funnelTags = getAllFunnelTags(p);
        var weinart    = normalizeWeinart(p.weinart);

        if (p.price < preisMin) return false;
        if (profile.requireTag && funnelTags.indexOf(profile.requireTag) === -1) return false;
        if (profile.isAusgefallen) {
          var tags      = normalizeTags(p.tags);
          var rebsorte  = p.rebsorte ? (Array.isArray(p.rebsorte) ? p.rebsorte[0] || '' : String(p.rebsorte)).trim().toLowerCase() : '';
          var isOrange  = (weinart === 'orange');
          var isNatur   = (tags.indexOf('naturwein') !== -1);
          var isPetNat  = (tags.indexOf('pét-nat') !== -1 || tags.indexOf('pet-nat') !== -1);
          var isSelten  = (rebsorte && SELTENE_REBSORTEN.indexOf(rebsorte) !== -1);
          if (!isOrange && !isNatur && !isPetNat && !isSelten) return false;
        }
        if (profile.geschmackTag && funnelTags.indexOf(profile.geschmackTag) === -1) return false;
        if (profile.geschmackTags && !profile.geschmackTags.some(function (t) { return funnelTags.indexOf(t) !== -1; })) return false;
        if (farbeTag && weinart !== farbeTag) return false;

        return true;
      });

      // Preisfilter: useRange = globale Logik (-10%/+20%); fixedMax = max fest, min iterativ nach unten; sonst: hartes Fenster
      // Bei max>=100 (Premium-Tier ohne echte Obergrenze): alle Kandidaten ab giftMin zeigen
      var result;
      if (profile.useRange) {
        result = giftMax >= 100
          ? candidates.filter(function (p) { return p.price >= giftMin; })
          : applyBudgetRange(candidates, giftMax);
      } else if (profile.fixedMax) {
        var step = 0;
        do {
          var lo = Math.max(preisMin, giftMax * (0.9 - step * 0.1));
          result = candidates.filter(function (p) { return p.price >= lo && p.price <= giftMax; });
          step++;
        } while (result.length === 0 && step <= 10);
        if (result.length === 0) result = candidates.filter(function (p) { return p.price <= giftMax; });
      } else {
        result = candidates.filter(function (p) {
          return p.price >= giftMin && p.price <= giftMax;
        });
      }

      return result;
    }

    // ---- Standard-Funnel ----
    var speiseTags   = getActiveSpeiseTags();
    var geschmackTag = (state.geschmack && state.geschmack !== 'null') ? state.geschmack.toLowerCase() : null;
    var farbeTagStd  = (state.farbe     && state.farbe     !== 'null') ? state.farbe.toLowerCase()     : null;

    var result = products.filter(function (p) {
      var funnelTags = getAllFunnelTags(p);
      var weinart    = normalizeWeinart(p.weinart);

      if (!speiseTags.every(function (t) { return funnelTags.indexOf(t) !== -1; })) return false;
      if (geschmackTag && funnelTags.indexOf(geschmackTag) === -1) return false;
      if (farbeTagStd  && weinart !== farbeTagStd)                 return false;
      return true;
    });

    if (state.budget > 0) result = applyBudgetRange(result, state.budget);
    return result;
  }

  // ---------------------------------------------------------------------------
  // scoreProductsAlltag — Scoring-basiertes Ranking für den Alltag-Funnel
  // ---------------------------------------------------------------------------

  function scoreProductsAlltag() {
    var products = window.WEINFINDER_PRODUCTS || [];
    var lust     = state.lust;
    var budget   = state.lustBudget;
    var month    = new Date().getMonth(); // 0=Jan … 11=Dez
    var isSummer = month >= 2 && month <= 7;
    var now      = Date.now();
    var DAYS_30  = 30 * 24 * 60 * 60 * 1000;

    // Budget-Range-Filter
    var pool = budget > 0 ? applyBudgetRange(products, budget) : products;

    var scored = pool.map(function (p) {
      var score    = 0;
      var weinart  = getProductWeinart(p);
      var funnelTags = getAllFunnelTags(p);
      var tags     = normalizeTags(p.tags);
      var rebsorte = p.rebsorte
        ? (Array.isArray(p.rebsorte) ? p.rebsorte[0] || '' : String(p.rebsorte)).trim().toLowerCase()
        : '';

      // --- Weinart-Filter & Basis-Score ---
      if (lust && lust.weinart !== null) {
        // 4 Standard-Optionen: Hard-Filter auf Weinart
        if (weinart !== lust.weinart) return null;
        score += 20;
      } else if (lust && lust.id === 'ausgefallen') {
        // Hard-Filter: nur Orange, Naturwein, Pét-Nat oder seltene Rebsorte
        var isOrange  = (weinart === 'orange');
        var isNatur   = (tags.indexOf('naturwein') !== -1);
        var isPetNat  = (tags.indexOf('pét-nat') !== -1 || tags.indexOf('pet-nat') !== -1);
        var isSelten  = (rebsorte && SELTENE_REBSORTEN.indexOf(rebsorte) !== -1);
        if (!isOrange && !isNatur && !isPetNat && !isSelten) return null;
        if (isOrange)  score += 5;
        if (isNatur)   score += 5;
        if (isPetNat)  score += 5;
        if (isSelten)  score += 5;
      } else if (lust && lust.id === 'ueberrasch') {
        // Alle Weinarten, Basis-Score
        score += 10;
      }

      // --- Geschmack-Tags (mehr Tags = leicht bevorzugt) ---
      funnelTags.forEach(function (t) {
        if (t.indexOf('geschmack-') === 0) score += 2;
      });

      // --- Saisonaler Bonus ---
      if (isSummer && (weinart === 'rose' || weinart === 'weiss' || weinart === 'schaumwein')) score += 3;
      if (!isSummer && weinart === 'rot') score += 3;

      // --- Lagerbestand-Bonus ---
      if ((p.inventory || 0) > 12) score += 2;

      // --- Neuheit-Bonus ---
      if (p.created_at) {
        var created = new Date(p.created_at).getTime();
        if (now - created < DAYS_30) score += 4;
      }

      // --- Zufalls-Faktor (für Shuffle) ---
      score += Math.random() * 4;

      return { product: p, score: score };
    }).filter(function (item) { return item !== null; });

    scored.sort(function (a, b) { return b.score - a.score; });

    // Bereits gezeigte Weine ausschließen
    var unseen = scored.filter(function (item) {
      return state.alltagShown.indexOf(item.product.id) === -1;
    });

    // Wenn weniger als 3 ungesehene übrig → alle bisherigen vergessen und neu starten
    if (unseen.length < 3) {
      state.alltagShown = [];
      unseen = scored;
    }

    var top3 = unseen.slice(0, 3).map(function (item) { return item.product; });

    // Gezeigte IDs merken
    top3.forEach(function (p) {
      if (state.alltagShown.indexOf(p.id) === -1) state.alltagShown.push(p.id);
    });

    return top3;
  }

  // ---------------------------------------------------------------------------
  // buildCardHtml — einheitliches Produktkarten-HTML
  // ---------------------------------------------------------------------------

  function buildCardHtml(product) {
    var priceFormatted = formatPrice(parseFloat(product.price) || 0);
    var imgSrc      = product.image || '';
    var imgSrcSmall = imgSrc.replace('width=800', 'width=400');
    var imgHtml = imgSrc
      ? '<img class="wf-product-img"' +
          ' src="' + escHtml(imgSrc) + '"' +
          ' srcset="' + escHtml(imgSrcSmall) + ' 400w, ' + escHtml(imgSrc) + ' 800w"' +
          ' sizes="(min-width: 720px) 260px, (min-width: 480px) 50vw, 100vw"' +
          ' alt="' + escHtml(product.title) + '" loading="lazy">'
      : '<div class="wf-product-img-placeholder">Kein Bild</div>';

    var tags  = normalizeTags(product.tags);
    var anbau = (product.anbaumethode || '').toLowerCase();
    var isBio = tags.indexOf('bio') !== -1 || tags.indexOf('biowein') !== -1 ||
                anbau.indexOf('bio') !== -1 || anbau.indexOf('organisch') !== -1;
    var badges = '';
    if (isBio) badges += '<span class="wf-badge wf-badge--bio">Bio</span>';
    if (tags.indexOf('piwi') !== -1) badges += '<span class="wf-badge wf-badge--piwi">Piwi</span>';
    if (tags.indexOf('naturwein') !== -1) badges += '<span class="wf-badge wf-badge--natur">Naturwein</span>';
    if (tags.indexOf('direktimport') !== -1) badges += '<span class="wf-badge wf-badge--direkt">Direktimport</span>';
    if (product.inventory > 0 && product.inventory < 10)
      badges += '<span class="wf-badge wf-badge--knapp">Fast ausverkauft</span>';

    var scoreRaw  = parseInt(product.weinscore, 10);
    var scoreHtml = !isNaN(scoreRaw)
      ? '<div class="wf-weinscore"><span class="wf-weinscore__label">Weinscore</span><span class="wf-weinscore__value">' + scoreRaw + '</span></div>'
      : '';

    var overlayHtml = badges ? '<div class="wf-card-badges-overlay">' + badges + '</div>' : '';

    var regionHtml = product.region
      ? '<p class="wf-product-region">' + escHtml(product.region) + '</p>'
      : '';

    var desc = product.kurzbeschreibung || '';
    if (desc.length > 120) desc = desc.slice(0, 117) + '…';
    var descHtml = desc ? '<p class="wf-alltag-desc">' + escHtml(desc) + '</p>' : '';

    var variantId    = product.variant_id != null ? product.variant_id : '';
    var cartLabel    = variantId ? 'In den Warenkorb' : 'Nicht verfügbar';
    var cartDisabled = variantId ? '' : ' disabled';

    return '<div class="wf-product-card">' +
      '<div class="wf-card-img-wrap">' +
        '<a href="' + escHtml(product.url) + '">' + imgHtml + '</a>' +
        overlayHtml +
      '</div>' +
      '<div class="wf-product-info">' +
        (scoreHtml ? '<div class="wf-meta-row">' + scoreHtml + '</div>' : '') +
        regionHtml +
        '<h3 class="wf-product-title">' +
          '<a href="' + escHtml(product.url) + '">' + escHtml(product.title) + '</a>' +
        '</h3>' +
        descHtml +
        '<div class="wf-product-price">' + priceFormatted + unitPriceHtml(product) + '</div>' +
        '<button' +
          ' class="wf-btn-cart"' +
          ' type="button"' +
          ' data-variant-id="' + escHtml(String(variantId)) + '"' +
          ' data-title="' + escHtml(product.title) + '"' +
          cartDisabled +
        '>' + cartLabel + '</button>' +
      '</div>' +
    '</div>';
  }

  // ---------------------------------------------------------------------------
  // renderAlltagResults — Top-3-Karten für den Alltag-Funnel
  // ---------------------------------------------------------------------------

  function renderAlltagResults() {
    var top3    = scoreProductsAlltag();
    var grid    = document.getElementById('wf-products-grid');
    var subtitle = document.getElementById('wf-results-subtitle');
    if (!grid) return;

    grid.className = 'wf-products-grid';

    var shuffleWrap = document.getElementById('wf-shuffle-wrap');
    if (shuffleWrap) shuffleWrap.style.display = '';

    if (top3.length === 0) {
      if (subtitle) subtitle.textContent = 'Keine Weine im Budget gefunden.';
      grid.innerHTML =
        '<div class="wf-no-results">' +
          '<div class="wf-no-results-icon">🍷</div>' +
          '<p>Kein passender Wein im Budget gefunden.</p>' +
          '<p>Versuche einen höheren Betrag oder wähle eine andere Option.</p>' +
        '</div>';
      return;
    }

    if (subtitle) subtitle.textContent = 'Deine Top 3 für heute';

    var html = '';
    top3.forEach(function (product) { html += buildCardHtml(product); });
    grid.innerHTML = html;
  }

  // ---------------------------------------------------------------------------
  // shuffleWithAnimation
  // ---------------------------------------------------------------------------

  function shuffleWithAnimation() {
    var grid = document.getElementById('wf-products-grid');
    var btn  = document.querySelector('.wf-btn-shuffle');
    if (!grid) return;

    // 1. Sofortiges Button-Feedback
    if (btn) {
      btn.classList.add('wf-shuffle-active');
      btn.disabled = true;
    }

    // 2. Alte Karten ausblenden
    var oldCards = grid.querySelectorAll('.wf-product-card');
    oldCards.forEach(function (card) {
      card.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
      card.style.opacity    = '0';
      card.style.transform  = 'translateY(-10px)';
    });

    var isAlltag = !!(state.anlass && state.anlass.id === 'alltag');

    // 3. Nach Fade-out neue Karten laden und einblenden
    setTimeout(function () {
      if (isAlltag) {
        renderAlltagResults();
      } else {
        // Essen / Geschenk: nächste 3 aus sortierten currentResults
        var all = state.currentResults;
        if (all.length > 3) {
          state.shuffleOffset = (state.shuffleOffset + 3) % all.length;
          var slice = [];
          for (var i = 0; i < 3; i++) {
            slice.push(all[(state.shuffleOffset + i) % all.length]);
          }
          renderResultSlice(slice);
        }
      }

      var newCards = grid.querySelectorAll('.wf-product-card');
      newCards.forEach(function (card) { card.classList.add('wf-card-enter'); });

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          newCards.forEach(function (card) { card.classList.add('wf-card-visible'); });
        });
      });

      // 4. Aufräumen + Button zurücksetzen
      setTimeout(function () {
        newCards.forEach(function (card) {
          card.classList.remove('wf-card-enter', 'wf-card-visible');
        });
        if (btn) {
          btn.classList.remove('wf-shuffle-active');
          btn.disabled = false;
        }
      }, 500);

    }, 280);
  }

  // Rendert eine vorgegebene Produkt-Liste (Slice) in das Grid (ohne State-Änderung)
  function renderResultSlice(products) {
    var grid = document.getElementById('wf-products-grid');
    if (!grid) return;
    var html = '';
    products.forEach(function (product) { html += buildCardHtml(product); });
    grid.innerHTML = html;
  }

  // ---------------------------------------------------------------------------
  // Toast
  // ---------------------------------------------------------------------------

  var toastTimer = null;

  function showToast(msg, isError) {
    var toast = document.getElementById('wf-toast');
    if (!toast) return;

    if (toastTimer) { clearTimeout(toastTimer); toastTimer = null; }

    toast.textContent = msg;
    toast.style.backgroundColor = isError ? 'var(--weinrot)' : 'var(--naturgruen)';
    toast.classList.add('show');

    toastTimer = setTimeout(function () {
      toast.classList.remove('show');
      toastTimer = null;
    }, 3000);
  }

  // ---------------------------------------------------------------------------
  // renderResults
  // ---------------------------------------------------------------------------

  function formatPrice(price) {
    var str = price.toFixed(2).replace('.', ',');
    if (str.endsWith(',00')) str = str.slice(0, -3) + ',-';
    return str + '&nbsp;€';
  }

  function unitPriceHtml(product) {
    if (!product.unit_price || !product.unit_price_label) return '';
    var str = parseFloat(product.unit_price).toFixed(2).replace('.', ',');
    return '<span class="wf-unit-price">(' + str + '&nbsp;€&nbsp;/&nbsp;' + escHtml(product.unit_price_label) + ')</span>';
  }

  function renderResults() {
    // Alltag-Funnel hat eigenes Rendering + Shuffle
    if (state.anlass && state.anlass.id === 'alltag') {
      var resultsBudgetDivA = document.getElementById('wf-results-budget');
      if (resultsBudgetDivA) resultsBudgetDivA.style.display = 'none';
      try {
        renderAlltagResults();
      } catch (err) {
        console.error('[Weinfinder] renderAlltagResults error:', err);
        var grid = document.getElementById('wf-products-grid');
        if (grid) grid.innerHTML = '<div class="wf-no-results"><div class="wf-no-results-icon">🍷</div><p>Etwas ist schiefgelaufen. Bitte versuche es erneut.</p></div>';
      }
      return;
    }

    // Shuffle-Button verstecken (nicht im Standard-Flow)
    var shuffleWrap = document.getElementById('wf-shuffle-wrap');
    if (shuffleWrap) shuffleWrap.style.display = 'none';

    // Grid-Klasse zurücksetzen
    var gridEl = document.getElementById('wf-products-grid');
    if (gridEl) gridEl.className = 'wf-products-grid';

    var resultsBudgetDiv = document.getElementById('wf-results-budget');
    if (resultsBudgetDiv) {
      var cfg           = window.WEINFINDER_CONFIG || {};
      var showInResults = cfg.show_budget && cfg.budget_position === 'results';
      resultsBudgetDiv.style.display = showInResults ? '' : 'none';
      if (showInResults) {
        var s = document.getElementById('wf-results-budget-slider');
        var a = document.getElementById('wf-results-budget-amount');
        if (s) { s.value = state.budget; s.setAttribute('aria-valuenow', state.budget); updateSliderGradient(s); }
        if (a) a.textContent = state.budget;
      }
    }

    var matched  = filterProducts();
    matched.sort(function (a, b) { return (b.inventory || 0) - (a.inventory || 0); });
    state.currentResults = matched;
    state.shuffleOffset  = 0;
    var grid     = document.getElementById('wf-products-grid');
    var subtitle = document.getElementById('wf-results-subtitle');

    if (!grid) return;

    if (subtitle) {
      if (matched.length === 0) {
        subtitle.textContent = 'Leider keine passenden Weine gefunden.';
      } else if (state.anlass && state.anlass.id === 'speise') {
        var FARBE_WEIN = {
          'rot':        { singular: 'Rotwein',      plural: 'Rotweine' },
          'weiss':      { singular: 'Weißwein',     plural: 'Weißweine' },
          'rose':       { singular: 'Rosé',         plural: 'Rosés' },
          'orange':     { singular: 'Orangewein',   plural: 'Orangeweine' },
          'schaumwein': { singular: 'Schaumwein',   plural: 'Schaumweine' }
        };
        var GESCHMACK_ADJ = {
          'geschmack-trocken':    { singular: 'trocken & mineralischen', plural: 'trocken & mineralische' },
          'geschmack-fruchtig':   { singular: 'fruchtig & frischen',    plural: 'fruchtig & frische' },
          'geschmack-vollmundig': { singular: 'vollmundig & komplexen', plural: 'vollmundig & komplexe' },
          'geschmack-sueslich':   { singular: 'rund & gefälligen',      plural: 'rund & gefällige' }
        };
        var isSingle = matched.length === 1;
        var folgend  = isSingle ? 'folgenden' : 'folgende';

        var geschmackAdj = '';
        if (state.geschmack && state.geschmack !== 'null' && GESCHMACK_ADJ[state.geschmack.toLowerCase()]) {
          geschmackAdj = isSingle
            ? GESCHMACK_ADJ[state.geschmack.toLowerCase()].singular
            : GESCHMACK_ADJ[state.geschmack.toLowerCase()].plural;
        }

        var weinNoun;
        if (state.farbe && state.farbe !== 'null' && FARBE_WEIN[state.farbe.toLowerCase()]) {
          weinNoun = isSingle
            ? FARBE_WEIN[state.farbe.toLowerCase()].singular
            : FARBE_WEIN[state.farbe.toLowerCase()].plural;
        } else {
          weinNoun = isSingle ? 'Wein' : 'Weine';
        }

        var essenPhrase = '';
        if (state.essen) {
          essenPhrase = state.essenSub
            ? (state.essenSub.phrase || state.essenSub.label)
            : (state.essen.phrase || state.essen.label);
        }

        var satz = 'Wir empfehlen ' + folgend;
        if (geschmackAdj) satz += ' ' + geschmackAdj;
        satz += ' ' + weinNoun + ' zu ' + essenPhrase + '.';
        subtitle.textContent = satz;
      } else if (matched.length === 1) {
        subtitle.textContent = '1 Wein gefunden';
      } else {
        subtitle.textContent = matched.length + ' Weine gefunden';
      }
    }

    shuffleWrap = document.getElementById('wf-shuffle-wrap');
    var showAllBtn  = document.querySelector('.wf-btn-showall');

    if (matched.length === 0) {
      if (shuffleWrap) shuffleWrap.style.display = 'none';
      if (showAllBtn)  showAllBtn.style.display  = 'none';
      grid.innerHTML =
        '<div class="wf-no-results">' +
          '<div class="wf-no-results-icon">🍷</div>' +
          '<p>Wir haben leider keinen Wein gefunden, der genau deinen Kriterien entspricht.</p>' +
          '<p>Versuch es mit anderen Filtern – z.&nbsp;B. ein höheres Budget oder eine andere Farbe.</p>' +
        '</div>';
      return;
    }

    // Dreier-Karten: nur erste 3 anzeigen
    var toRender = matched.slice(0, 3);

    // Shuffle-Button + "Alle anzeigen" nur einblenden wenn mehr als 3 Treffer
    if (shuffleWrap) shuffleWrap.style.display = matched.length > 3 ? '' : 'none';
    if (showAllBtn) showAllBtn.style.display = matched.length > 3 ? '' : 'none';

    var html = '';
    toRender.forEach(function (product) { html += buildCardHtml(product); });
    grid.innerHTML = html;
  }

  // ---------------------------------------------------------------------------
  // addToCart
  // ---------------------------------------------------------------------------

  async function addToCart(variantId, title, btn) {
    var config       = window.WEINFINDER_CONFIG || {};
    var originalText = btn.textContent;

    btn.disabled    = true;
    btn.textContent = '…';

    var isAlltag   = !!(state.anlass && state.anlass.id === 'alltag');
    var isGeschenk = !!(state.empfaenger);

    var selectionString;
    if (isAlltag) {
      selectionString = [
        'Anlass:FürMich',
        state.lust ? 'Lust:' + state.lust.label : null,
        'Budget:bis' + state.lustBudget + 'EUR',
      ].filter(Boolean).join('|');
    } else if (isGeschenk) {
      selectionString = [
        'Anlass:Geschenk',
        'Empfaenger:' + state.empfaenger.label,
        state.farbe ? 'Farbe:' + state.farbe : null,
        state.giftBudget ? 'Budget:' + state.giftBudget.label : null,
      ].filter(Boolean).join('|');
    } else {
      selectionString = [
        'Anlass:'    + (state.anlass    ? state.anlass.label    : ''),
        state.essen    ? 'Essen:'     + state.essen.label    : null,
        state.essenSub ? 'Sub:'       + state.essenSub.label : null,
        'Farbe:'     + (state.farbe    || 'Überrasch mich'),
        'Geschmack:' + (state.geschmack || 'Überrasch mich'),
        'Budget:bis' + state.budget + 'EUR',
      ].filter(Boolean).join('|');
    }

    var attributes = {
      weinfinder_used:              'true',
      weinfinder_selections:        selectionString,
      weinfinder_discount_eligible: 'true',
    };
    if (isAlltag) {
      attributes.weinfinder_funnel  = 'fuer-mich';
      attributes.weinfinder_lust    = state.lust ? state.lust.id : '';
      attributes.weinfinder_budget  = String(state.lustBudget);
    } else if (isGeschenk) {
      attributes.weinfinder_funnel      = 'geschenk';
      attributes.weinfinder_empfaenger  = state.empfaenger.id;
      attributes.weinfinder_budget      = state.giftBudget ? state.giftBudget.id : '';
    }

    var cartSource = isAlltag ? 'weinfinder-fuer-mich' : (isGeschenk ? 'weinfinder-geschenk' : 'weinfinder');

    try {
      var addRes = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({
          id:         variantId,
          quantity:   1,
          properties: { _source: cartSource },
        }),
      });

      if (!addRes.ok) {
        var errData = await addRes.json().catch(function () { return {}; });
        throw new Error(errData.description || errData.message || 'Fehler beim Hinzufügen');
      }

      await fetch('/cart/update.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ attributes: attributes }),
      });

      if (config.enable_discount && config.discount_code) {
        fetch('/discount/' + encodeURIComponent(config.discount_code)).catch(function () {});
      }

      showToast('„' + title + '" wurde in den Warenkorb gelegt.', false);
      btn.textContent = '✓ Hinzugefügt';
      setTimeout(function () {
        btn.textContent = originalText;
        btn.disabled    = false;
      }, 2500);

    } catch (err) {
      console.error('[Weinfinder] addToCart error:', err);
      showToast('Fehler: ' + (err.message || 'Unbekannter Fehler'), true);
      btn.textContent = originalText;
      btn.disabled    = false;
    }
  }

  // ---------------------------------------------------------------------------
  // Option click handler
  // ---------------------------------------------------------------------------

  var navigating = false;

  function handleOptionClick(btn) {
    var step = btn.closest('.wf-step').dataset.step;

    btn.closest('.wf-step').querySelectorAll('.wf-option')
      .forEach(function (b) { b.classList.remove('selected'); });
    btn.classList.add('selected');

    if (step === 'anlass') {
      var anlassId   = btn.dataset.anlassId;
      state.anlass   = ANLASS_OPTIONS.find(function (o) { return o.id === anlassId; }) || null;
      state.essen    = null;
      state.essenSub = null;

    } else if (step === 'essen') {
      var essenId    = btn.dataset.essenId;
      state.essen    = ESSEN_OPTIONS.find(function (o) { return o.id === essenId; }) || null;
      state.essenSub = null;

    } else if (step === 'essensub') {
      var subId      = btn.dataset.essensubId;
      var followups  = state.essen ? (ESSEN_FOLLOWUPS[state.essen.id] || []) : [];
      state.essenSub = followups.find(function (o) { return o.id === subId; }) || null;

    } else if (step === 'farbe') {
      var rawF    = btn.dataset.tag;
      state.farbe = rawF === 'null' ? null : rawF;

    } else if (step === 'geschmack') {
      var rawG        = btn.dataset.tag;
      state.geschmack = rawG === 'null' ? null : rawG;

    } else if (step === 'empfaenger') {
      var empfaengerId = btn.dataset.empfaengerId;
      state.empfaenger = EMPFAENGER_OPTIONS.find(function (o) { return o.id === empfaengerId; }) || null;
      state.farbe      = null;
      state.giftBudget = null;

    } else if (step === 'lust') {
      var lustId  = btn.dataset.lustId;
      state.lust  = LUST_OPTIONS.find(function (o) { return o.id === lustId; }) || null;

    } else if (step === 'giftbudget') {
      var giftBudgetId = btn.dataset.giftbudgetId;
      state.giftBudget = GIFT_BUDGET_OPTIONS.find(function (o) { return o.id === giftBudgetId; }) || null;
      if (state.giftBudget) state.budget = state.giftBudget.max;
    }

    if (!navigating) {
      navigating = true;
      setTimeout(function () { navigating = false; goNext(); }, 280);
    }
  }

  // ---------------------------------------------------------------------------
  // restart
  // ---------------------------------------------------------------------------

  function restart() {
    state.stepHistory = ['anlass'];
    state.anlass      = null;
    state.essen       = null;
    state.essenSub    = null;
    state.farbe       = null;
    state.geschmack   = null;
    state.budget      = 20;
    state.empfaenger  = null;
    state.giftBudget  = null;
    state.lust        = null;
    state.lustBudget  = 14;
    state.alltagShown    = [];
    state.currentResults = [];
    state.shuffleOffset  = 0;

    var shuffleWrap = document.getElementById('wf-shuffle-wrap');
    if (shuffleWrap) shuffleWrap.style.display = 'none';

    var slider  = document.getElementById('wf-budget-slider');
    var display = document.getElementById('wf-budget-amount');
    if (slider)  { slider.value = 20; slider.setAttribute('aria-valuenow', 20); updateSliderGradient(slider); }
    if (display) display.textContent = '20';

    var resultsSlider  = document.getElementById('wf-results-budget-slider');
    var resultsDisplay = document.getElementById('wf-results-budget-amount');
    if (resultsSlider)  { resultsSlider.value = 20; resultsSlider.setAttribute('aria-valuenow', 20); updateSliderGradient(resultsSlider); }
    if (resultsDisplay) resultsDisplay.textContent = '20';

    document.querySelectorAll('.wf-option.selected').forEach(function (b) { b.classList.remove('selected'); });
    document.querySelectorAll('.wf-step').forEach(function (s) { s.classList.remove('active', 'visible'); });

    updateProgress();
    var firstStep = document.querySelector('.wf-step[data-step="anlass"]');
    if (firstStep) activateStepEl(firstStep);
  }

  // ---------------------------------------------------------------------------
  // Slider gradient helper
  // ---------------------------------------------------------------------------

  function updateSliderGradient(slider) {
    var min = parseInt(slider.min, 10) || 8;
    var max = parseInt(slider.max, 10) || 40;
    var pct = ((parseInt(slider.value, 10) - min) / (max - min)) * 100;
    slider.style.background =
      'linear-gradient(to right, var(--naturgruen) ' + pct + '%, var(--border) ' + pct + '%)';
  }

  // ---------------------------------------------------------------------------
  // init
  // ---------------------------------------------------------------------------

  function init() {
    var root = getRoot();
    if (!root) return;

    root.addEventListener('click', function (e) {
      var optBtn = e.target.closest('.wf-option');
      if (optBtn) { handleOptionClick(optBtn); return; }

      var gotoBtn = e.target.closest('[data-goto]');
      if (gotoBtn) {
        var goto = gotoBtn.dataset.goto;
        if (goto === 'prev')      goPrev();
        else if (goto === 'next') goNext();
        else                      goToStep(goto);
        return;
      }

      var cartBtn = e.target.closest('.wf-btn-cart');
      if (cartBtn) {
        addToCart(parseInt(cartBtn.dataset.variantId, 10), cartBtn.dataset.title || '', cartBtn);
        return;
      }

      var restartBtn = e.target.closest('.wf-btn-restart');
      if (restartBtn) { restart(); return; }

      var shuffleBtn = e.target.closest('.wf-btn-shuffle');
      if (shuffleBtn) { shuffleWithAnimation(); return; }

      var showAllBtn = e.target.closest('.wf-btn-showall');
      if (showAllBtn) {
        var allProducts = state.currentResults;
        var grid     = document.getElementById('wf-products-grid');
        var subtitle = document.getElementById('wf-results-subtitle');
        var shuffleWrap = document.getElementById('wf-shuffle-wrap');
        if (!grid || !allProducts.length) return;
        renderResultSlice(allProducts);
        if (shuffleWrap) shuffleWrap.style.display = 'none';
        if (subtitle) subtitle.textContent = allProducts.length + ' Weine gefunden';
        return;
      }
    });

    // --- Budget slider (eigener Schritt) ---
    var slider   = document.getElementById('wf-budget-slider');
    var amountEl = document.getElementById('wf-budget-amount');
    if (slider) {
      updateSliderGradient(slider);
      slider.addEventListener('input', function () {
        var val    = parseInt(slider.value, 10);
        state.budget = val;
        slider.setAttribute('aria-valuenow', val);
        if (amountEl) amountEl.textContent = val;
        updateSliderGradient(slider);
      });
    }

    // --- Budget slider (bei Ergebnissen) ---
    var resultsSlider   = document.getElementById('wf-results-budget-slider');
    var resultsAmountEl = document.getElementById('wf-results-budget-amount');
    if (resultsSlider) {
      updateSliderGradient(resultsSlider);
      resultsSlider.addEventListener('input', function () {
        var val    = parseInt(resultsSlider.value, 10);
        state.budget = val;
        resultsSlider.setAttribute('aria-valuenow', val);
        if (resultsAmountEl) resultsAmountEl.textContent = val;
        updateSliderGradient(resultsSlider);
        renderResults();
      });
    }

    // --- Initial step ---
    updateProgress();
    var firstStep = document.querySelector('.wf-step[data-step="anlass"]');
    if (firstStep) activateStepEl(firstStep);
  }

  // ---------------------------------------------------------------------------
  // Boot
  // ---------------------------------------------------------------------------

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
